import { __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { request } from '../../xhr';
import { getCurrentGallection } from '../selectors';
import { deselectAll } from '../actions';
import setGallectionCover from './setGallectionCover';
import updateGallectionSize from './updateGallectionSize';
export default function (action) {
    var _a, deviationIds, targetFolderId, currentGallection, params;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, deviationIds = _a.deviationIds, targetFolderId = _a.targetFolderId;
                return [4 /*yield*/, select(function (state) { return ({
                        currentGallection: getCurrentGallection(state),
                    }); })];
            case 1:
                currentGallection = (_b.sent()).currentGallection;
                return [4 /*yield*/, put(deselectAll())];
            case 2:
                _b.sent();
                return [4 /*yield*/, call(setGallectionCover, {
                        folderId: targetFolderId,
                        deviationId: deviationIds[0],
                        onlyIfMissing: true,
                    })];
            case 3:
                _b.sent();
                return [4 /*yield*/, call(updateGallectionSize, targetFolderId, deviationIds.length)];
            case 4:
                _b.sent();
                params = {
                    type: currentGallection.type,
                    target_folderid: targetFolderId,
                    deviationids: deviationIds,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/copy_deviations',
                        data: params,
                    })];
            case 5:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=copyDeviations.js.map